<template>
  <div class="m-video">
    <div v-if="!cookieConsent.marketing" class="col-12 px-0">
      <base-image
        :url="item.image && item.image[0] ? item.image[0].url : ''"
        :width="965"
        :height="525"
        :alt-text="item.imageAltText"
        image-class="m-video__image"
      />

      <div class="m-video__wrapper">
        <p class="m-video__video-cookies-alert pt-5 pt-md-0">
          {{ $t('videoCookies', 'Vi har en rigtig fin video, som vi gerne vil vise dig. Men før du kan se den, så skal du klikke her og') }}
          <a class="m-video__link" href="javascript:Cookiebot.renew()">{{ $t('acceptMarketingCookies', 'acceptere marketing cookies') }}</a>.
        </p>
      </div>
      <div class="m-video__video-btn d-none d-md-flex">
        <base-icon
          onclick="javascript:Cookiebot.renew()"
          class="m-video__video-btn-icon"
          icon="play"
        />
      </div>
    </div>


    <div
      v-if="cookieConsent.marketing"
      ref="videoContainer"
      class="position-relative w-100 h-100 overflow-hidden"
    >
      <transition
        name="fade"
        mode="out-in"
      >
        <base-image
          :url="item.image && item.image[0] ? item.image[0].url : ''"
          :width="965"
          :height="525"
          :alt-text="item.imageAltText"
          image-class="m-video__image"
        />
      </transition>

      <client-only>
        <youtube
          ref="video"
          class="m-video__video h-100 w-100"
          :class="{
            '-active': hideImage,
            '-paused': showModal
          }"
          :mute="true"
          :player-vars="options"
          :video-id="item.youTubeVideoIntroID"
          host="https://www.youtube-nocookie.com"
          @ready="ready"
          @playing="playing"
        />
      </client-only>
      <div
        v-if="$isNotNullOrUndefined(item.youTubeVideoID)"
        class="m-video__video-btn-container"
        @click="toggleModal"
      >
        <div class="m-video__video-btn">
          <base-icon
            class="m-video__video-btn-icon"
            icon="play"
          />
        </div>
      </div>

      <client-only v-if="showModal">
        <portal to="modal">
          <modal
            :visible="showModal"
            @close="toggleModal"
          >
            <client-only>
              <youtube
                class="h-100"
                player-width="965"
                player-height="625"
                :player-vars="modalVideoOptions"
                :video-id="item.youTubeVideoID"
                host="https://www.youtube-nocookie.com"
              />
            </client-only>
            <template #close>
              <base-icon icon="close" />
            </template>
          </modal>
        </portal>
      </client-only>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/atoms/BaseIcon';
import Modal from '@/components/molecules/Modal';
import BaseImage from '@/components/atoms/BaseImage';
import { Youtube } from 'vue-youtube';

export default {
  name: 'Video',
  components: {
    BaseIcon,
    Modal,
    BaseImage,
    Youtube
  },
  props: {
    item: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      isActive: false,
      hideImage: false,
      player: null,
      cookieConsent: {
        marketing: false,
        statistics: false,
        preferences: false
      },
      options: {
        modestbranding: 1,
        autoplay: 1,
        playsinline: 1,
        rel: 0,
        iv_load_policy: 3,
        controls: 0,
        autoHide: 1,
        loop: 1,
        mute: true,
        enablejsapi: 1,
        playlist: this.item.youTubeVideoIntroID
      },
      modalVideoOptions: {
        autoplay: 1,
        start: 0
      },
      showModal: false
    };
  },
  watch: {
    isActive () {
      if (this.isActive && this.player) {
        this.hideImage = true;
        this.player.playVideo();
      } else if (this.player) {
        this.hideImage = false;
        this.player.pauseVideo();
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setVideoSize);
  },
  mounted () {
    let self = this;
    this.cookieConsent = window.Cookiebot?.consent;
    window.addEventListener('CookiebotOnConsentReady', function () {
      self.cookieConsent = window.Cookiebot?.consent;
    }, false);
    window.addEventListener('CookiebotOnAccept', function () {
      self.cookieConsent = window.Cookiebot?.consent;
    }, false);
    window.addEventListener('CookiebotOnDecline', function () {
      self.cookieConsent = window.Cookiebot?.consent;
    }, false);
    if (this.hideImage) {
      window.addEventListener('resize', this.setVideoSize);
    }
  },
  methods: {
    ready (event) {
      this.player = event;
      this.isActive = true;
    },
    playing () {
      this.hideImage = true;
    },
    setVideoSize () {
      if (this.$refs.video) {
        const container = this.$refs.videoContainer;
        const iframe = this.$refs.video.$el.firstElementChild;
        iframe.style.minWidth = container.offsetWidth + 'px';
        iframe.style.minHeight = container.offsetWidth * (9 / 16) + 'px';
        iframe.style.zIndex = '0';
      }
    },
    toggleModal () {
      if (this.showModal && this.player) {
        this.showModal = false;
        this.hideImage = true;
        this.player.playVideo();
      } else if (this.player) {
        this.showModal = true;
        this.hideImage = false;
        this.player.pauseVideo();
        this.modalVideoOptions.start = Math.round(this.player.getCurrentTime());
      }
    }
  }
};
</script>
